import { combineReducers } from 'redux'

import { reducer as user } from './reduxStore/user';
import { reducer as colorTheme } from './reduxStore/colorTheme';
import { reducer as session } from './reduxStore/session';
import { reducer as navigation } from './reduxStore/navigation';
import { reducer as locale } from './reduxStore/locale';
import { reducer as profile } from './reduxStore/profile';
import { reducer as uiState } from './reduxStore/uiState';
import { reducer as systemModal } from './reduxStore/systemModal';

import { reducer as listLocale } from './reduxStore/lists/listLocale';
import { reducer as country } from './reduxStore/lists/country';
import { reducer as residenceCountry } from './reduxStore/lists/residenceCountry';
import { reducer as residenceState } from './reduxStore/lists/residenceState';
import { reducer as group } from './reduxStore/group';
import { reducer as groupUsers } from './reduxStore/groupUsers';

export default combineReducers({
  user,
  session,
  navigation,
  locale,
  uiState,
  systemModal,
  lists: combineReducers({
    colorTheme,
    locale: listLocale,
    profile,
    country,
    residenceCountry,
    residenceState,
    group,
    groupUsers,
  }),
});
